import type { ProductsState } from 'src/redux/products/types';
import { getViewProductsForDayLabel, MODAL_CONTROLS_CLOSE, NO_MATCHING_PRODUCTS } from './copy';

/**
 * The label shown on the "view results" CTA of a filter drawer. Shared by the
 * full listings-controls drawer and the per-facet drawer so both stay in sync.
 */
export const getViewResultsButtonText = (
  products: Pick<ProductsState, 'error' | 'totalProducts'>,
  guaranteedArrivalDayName?: string,
): string => {
  if (products.error) {
    return MODAL_CONTROLS_CLOSE;
  }

  if (products.totalProducts === 0) {
    return NO_MATCHING_PRODUCTS;
  }

  if (guaranteedArrivalDayName) {
    return getViewProductsForDayLabel(products.totalProducts, guaranteedArrivalDayName);
  }

  return `View ${products.totalProducts} products`;
};

/**
 * Whether the "view results" CTA is disabled. With nothing to view, closing the drawer
 * would only reveal an empty grid, so the customer stays among the filters and applied
 * pills that can get them out of it. Enabled while a request is in flight, since the
 * current total is about to be replaced.
 */
export const isViewResultsDisabled = (
  products: Pick<ProductsState, 'error' | 'pageLoading' | 'totalProducts'>,
): boolean => !products.error && products.pageLoading === null && products.totalProducts === 0;
